import React from "react";
import { Clock } from "lucide-react";
import { PageShell } from "../components/PageShell";
import { IdleRequestsQueue } from "../components/IdleRequestsPanel";

// Idle-time approval queue — reachable from Home → Idle time requests.
export default function InboxV2() {
  return (
    <PageShell
      title="Idle time requests"
      subtitle="Tracker idle time waiting on your review"
      icon={<Clock size={16} />}
    >
      <div style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
        <IdleRequestsQueue />
      </div>
    </PageShell>
  );
}
